import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { breakpointsBootstrapV5, useBreakpoints } from '@vueuse/core';
import { SolrFacet } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import FacetOptionsMulti from './FacetOptionsMulti.vue';
import FacetOptionsMultiDropdown from './FacetOptionsMultiDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetOptionsWrapper',
  props: {
    facet: {}
  },
  emits: ["change", "changeMultiple"],
  setup(__props: any, { emit }) {

const props = __props;





function change (name: string, value: string, type?: string): void {
    emit('change', name, value, type);
}

function changeMultiple (name: string, value: string[]): void {
    emit('changeMultiple', name, value);
}

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const largerThanLg = breakpoints.greater('lg');

return (_ctx: any,_cache: any) => {
  return (_unref(largerThanLg))
    ? (_openBlock(), _createBlock(FacetOptionsMulti, {
        key: 0,
        facet: props.facet,
        onChange: change
      }, null, 8 /* PROPS */, ["facet"]))
    : (_openBlock(), _createBlock(FacetOptionsMultiDropdown, {
        key: 1,
        facet: props.facet,
        onChangeMultiple: changeMultiple
      }, null, 8 /* PROPS */, ["facet"]))
}
}

})